var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLightning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_243_3886",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0248 4.99312C11.1731 4.99155 11.3079 5.07686 11.3699 5.20939C11.4372 5.35297 11.4162 5.51059 11.3308 5.61746L4.75586 13.8461C4.71056 13.894 4.67119 13.9256 4.61561 13.9515C4.50435 14.0032 4.38356 14.0055 4.27541 13.9481C4.11836 13.8731 4.01929 13.6905 4.06849 13.5064L5.25184 8.97724L0.382762 8.9922C0.234515 8.99378 0.0997323 8.90846 0.0376541 8.77594C-0.0244232 8.64341 -0.0086226 8.47474 0.0767666 8.36786L6.65689 0.150271C6.7653 0.00582462 6.95884 -0.0436782 7.12106 0.0423656C7.28921 0.112201 7.37715 0.299946 7.33909 0.478954L6.15574 5.00809L11.0248 4.99312Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_243_3886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0281 4.95184C11.1752 4.95026 11.3088 5.0349 11.3704 5.1663C11.4371 5.30869 11.4163 5.46503 11.3316 5.571L4.81099 13.7316C4.7661 13.7791 4.72706 13.8105 4.67194 13.8362C4.56158 13.8874 4.44176 13.8897 4.33451 13.8328C4.17878 13.7584 4.08053 13.5773 4.12931 13.3947L5.30288 8.90299L0.474079 8.91784C0.327058 8.91941 0.19339 8.83478 0.131825 8.70334C0.0702612 8.57194 0.0859313 8.40465 0.170614 8.29864L6.69634 0.149029C6.80385 0.00577644 6.99578 -0.043317 7.15665 0.0420154C7.32341 0.111273 7.4106 0.297465 7.37288 0.47499L6.19931 4.96669L11.0281 4.95184Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_243_3886",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0428 5.15224C11.191 5.15062 12.3547 5.77481 12.4169 5.9073C12.484 6.05089 12.4631 6.20854 12.3777 6.31537L5.80275 14.544C5.75745 14.5919 5.71808 14.6235 5.6625 14.6495C5.55124 14.7011 5.43041 14.7034 5.3223 14.646C5.16525 14.571 4.19377 13.7778 4.24294 13.5936L6.36075 10.158H1.74866C1.60041 10.1596 0.128389 8.74331 0.213778 8.63647C3.29563 4.6941 5.49585 1.89954 6.81443 0.252834C7.02994 -0.016299 8.00573 0.654244 8.16795 0.740288C8.3361 0.810124 8.42404 0.997868 8.38597 1.17687L7.20263 5.706L11.0428 5.15224Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_243_3886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0428 5.15224C11.191 5.15062 12.3547 5.77481 12.4169 5.9073C12.484 6.05089 12.4631 6.20854 12.3777 6.31537L5.80275 14.544C5.75745 14.5919 5.71808 14.6235 5.6625 14.6495C5.55124 14.7011 5.43041 14.7034 5.3223 14.646C5.16525 14.571 4.19377 13.7778 4.24294 13.5936L6.36075 10.158H1.74866C1.60041 10.1596 0.128389 8.74331 0.213778 8.63647C3.29563 4.6941 5.49585 1.89954 6.81443 0.252834C7.02994 -0.016299 8.00573 0.654244 8.16795 0.740288C8.3361 0.810124 8.42404 0.997868 8.38598 1.17688L7.20263 5.706L11.0428 5.15224Z",
    stroke: "currentColor",
    strokeWidth: 0.930593
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightning);
export default __webpack_public_path__ + "static/media/icon-lightning.f3393754ecdcc58194578624f2074351.svg";
export { ForwardRef as ReactComponent };